<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  fill="currentcolor"
  [attr.width]="size"
  [attr.height]="size"
  [ngClass]="direction"
>
  <title *ngIf="title">{{ title }}</title>

  <path *ngFor="let p of paths" [attr.d]="p" />
</svg>
